// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PdpBadges_wrapper__OaARs","badges":"PdpBadges_badges__AuOC1"};